import { HStack, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useSearchParams } from 'react-router-dom';

import { useLoginActionMessage } from '@/v5/@hooks/auth/login/useLoginActionMessage';
import { TcapLink } from '@/v5/components/atoms/Link/TcapLink';
import { LoginButtonGroup } from '@/v5/components/molecules/ButtonGroup/LoginButtonGroup';
import { EmailField } from '@/v5/components/molecules/FormField/EmailField';
import { PasswordField } from '@/v5/components/molecules/FormField/PasswordField';
import { AuthAlerts } from '@/v5/components/organisms/AuthAlerts/AuthAlerts';

function LoginNormal({
    isSubmitting,
    isChecked,
    loginError,
    setShowError,
    status,
    message,
    values,
    setValues,
    updateField,
}) {
    const [searchParams] = useSearchParams();
    const action = searchParams.get('action');
    const { loginActionMessage } = useLoginActionMessage(action);

    const handleFieldChange = (e) => {
        const { name: field, value } = e.target;
        setValues((prevState) => ({ ...prevState, [field]: value }));
        updateField(field, value);
    };

    return (
        <Stack spacing="6" aria-label="login-form-container">
            <Stack spacing="4">
                <Field
                    name="email"
                    component={EmailField}
                    value={values.email}
                    onChange={handleFieldChange}
                />
                <Field name="password" component={PasswordField} />
                <AuthAlerts
                    action={action}
                    loginActionMessage={loginActionMessage}
                    loginError={loginError}
                    message={message}
                    status={status}
                />
                <HStack role="group" justify="flex-end">
                    <TcapLink to="/forgot-password">Forgot password?</TcapLink>
                </HStack>

                <Stack role="group" spacing="4" aria-label="buttons container">
                    <LoginButtonGroup
                        isSubmitting={isSubmitting}
                        isChecked={isChecked}
                        setShowError={setShowError}
                    />
                </Stack>
            </Stack>
        </Stack>
    );
}

export { LoginNormal };
